// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CZgG","name":"styles_name__1mUpW","phone":"styles_phone__dVQ7B"};